import * as THREE from 'three';
import EventDispatcher from '../common/EventDispatcher';
import {
    isMobile,
    isMobileOnly
} from 'mobile-device-detect';
import {
    Global
} from '../common/global';
import { LineMaterial } from 'three/examples/jsm/lines/LineMaterial.js';
import { LineGeometry } from 'three/examples/jsm/lines/LineGeometry.js';
import { Line2 } from 'three/examples/jsm/lines/Line2.js';
import { laneInfo } from '../common/lanes';



// Map class definition
export default class Map {
    // Constructor takes a scene as a parameter
    constructor(scene) {
        this.scene = scene;

        this.onEvents=this.onEvents.bind(this)
    }

    // Initialization method for setting up event listeners and creating the mini-map
    init() {

        // Getting the event dispatcher instance
        this.events = EventDispatcher.getObj();

        // Initializing the final target look at vector
        this.finalTargetLookAt = null;

        // Adding event listeners for GAMESCENE_EVENTS and PLAYER_EVENTS
        this.events.addEventListener("GAMESCENE_EVENTS", this.onEvents);
        this.events.addEventListener("PLAYER_EVENTS", this.onEvents);

        // Creating an orthographic camera for the mini-map
        this.miniMapCamera = new THREE.OrthographicCamera(-100, 100, 100, -100, .1, 120);
        this.miniMapCamera.layers.set(2);

        // Creating a WebGLRenderer for the mini-map
        this.mapCanvas = document.querySelector('canvas.webgl2');
        this.miniMapRenderer = new THREE.WebGLRenderer({
            canvas: this.mapCanvas,
            antialias: false,
            precision: 'mediump',
            powerPreference: 'high-performance'
        });
        this.miniMapRenderer.setClearColor(0x61c6e8, 0); // Set clear color to black with alpha 0
        this.miniMapRenderer.physicallyCorrectLights = true;
        this.miniMapRenderer.shadowMap.enabled = true;
        this.miniMapRenderer.shadowMap.type = THREE.PCFSoftShadowMap;
        this.miniMapRenderer.toneMappingExposure = 0;
        this.miniMapRenderer.gammaFactor = 2.2;

        // Setting the size of the mini-map renderer based on a percentage of the window size
        this.miniMapRenderer.setSize(window.innerWidth * 0.3, window.innerWidth * 0.3);
        this.miniMapRenderer.setPixelRatio(Math.min(2, window.devicePixelRatio));

        // Appending the mini-map renderer's element to the HTML document
        // document.getElementById('miniMap').appendChild(this.miniMapRenderer.domElement); */




        
        const _level= Global.gameLevel>1?2:1;
        const scaleFactor = 20; // Scaling the path
        const scaledPoints = laneInfo[`level${_level}`]['lane3'].map(point =>
            new THREE.Vector3(point.x * scaleFactor, point.y * scaleFactor, point.z * scaleFactor)
        );
        // Convert points to an array for Line2
        const pointsArray = [];
        for (const point of scaledPoints) {
            pointsArray.push(point.x, point.y, point.z);
        }
        // Use LineGeometry for handling thicker lines
        const geometry = new LineGeometry();
        geometry.setPositions(pointsArray);

    
        const material = new LineMaterial({
            color: 0x61c6e8, // Red line
            linewidth: .02* window.innerHeight,
        });

        // Create and add the thick line to the scene
        this.curveLine = new Line2(geometry, material);
        // this.curveLine.computeLineDistances();
        this.scene.add(this.curveLine);

        this.curveLine.layers.set(2)
    }

    // Event handler for GAMESCENE_EVENTS and PLAYER_EVENTS
    onEvents(data) {
        switch (data['message']['event_type']) {
            case "update":
                // Updating the mini-map based on the scene data
                this.update(data['message']['data']);
                break;
            case "move_player":
                // Adjusting the mini-map camera to follow the player's position
                this.followPlayer(data['message']['data']);
                break;
        }
    }

    // Method to adjust the mini-map camera to follow the player's position
    followPlayer(data) {
        // Getting the player's car position and rotation
        let carPos = data.entity.position;

        // Setting the mini-map camera position based on the player's position and rotation
        this.miniMapCamera.position.set(carPos.x, carPos.y, carPos.z);

        // Making the mini-map camera look at the player's position
        this.miniMapCamera.position.copy(carPos).add(new THREE.Vector3(0, 100, 0));
        if (this.finalTargetLookAt === null) {
            this.finalTargetLookAt = carPos.clone().add(new THREE.Vector3(0, 0, 0).applyQuaternion(data.entity.quaternion));
        } else {
            this.finalTargetLookAt = new THREE.Vector3().lerpVectors(this.finalTargetLookAt, carPos.clone().add(new THREE.Vector3(0, 0, 0).applyQuaternion(data.entity.quaternion)), 1);
        }
        this.miniMapCamera.lookAt(this.finalTargetLookAt);
    }

    // Method to update and render the mini-map
    update(_data) {
        // Rendering the mini-map scene using the mini-map camera
        this.miniMapRenderer.render(this.scene, this.miniMapCamera);
    }
    dispose() {
        // Remove event listeners
        this.events.removeEventListener("GAMESCENE_EVENTS", this.onEvents);
        this.events.removeEventListener("PLAYER_EVENTS", this.onEvents);
    
        // Dispose of mini-map renderer
        this.miniMapRenderer.dispose();
    
        // Dispose of geometry and material for the curve line
        if (this.curveLine) {
            if (this.curveLine.geometry) {
                this.curveLine.geometry.dispose();
            }
            if (this.curveLine.material) {
                this.curveLine.material.dispose();
            }
            this.scene.remove(this.curveLine);
            this.curveLine = null;
        }
    
        // Remove mini-map canvas from the DOM if necessary
        if (this.mapCanvas && this.mapCanvas.parentNode) {
            this.mapCanvas.parentNode.removeChild(this.mapCanvas);
        }
    
        // Clear mini-map references
        this.miniMapRenderer = null;
        this.miniMapCamera = null;
        this.mapCanvas = null;
        this.finalTargetLookAt = null;
    }
    
}